import * as React from "react";
export default class LocationItem extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (this.props.active ? React.createElement("a", { href: this.props.buttonLink, className: "location-item" },
            React.createElement("div", { className: "location-caption__wrap" },
                React.createElement("div", { className: "location-caption", style: { backgroundColor: this.props.color || "#fff" } },
                    React.createElement("p", { className: "location-header" }, this.props.header),
                    React.createElement("p", { className: "location-title", style: { color: this.props.titleColor || "#fff" } }, this.props.title),
                    React.createElement("p", { className: "location-desc" }, this.props.desc),
                    React.createElement("span", { "data-href": this.props.buttonLink, className: "btn-primary btn-primary__clear" }, this.props.buttonText || "Click Here"))),
            React.createElement("div", { className: "location-img" },
                React.createElement("div", { className: "location-img__img", style: { backgroundImage: "url('" + this.props.imgPath + "')" } }),
                React.createElement("div", { className: "location-info" },
                    React.createElement("p", null, this.props.location),
                    React.createElement("p", null, this.props.drink)))) : null);
    }
}
;
//# sourceMappingURL=location-item.js.map